import { FC } from 'react';
import { useRouter } from 'next/router';

import { i18n as I18n } from 'utils/i18n';

import ModalDialog from '../modal';

interface Props {
  onCheckout?: () => any;
  onClose?: () => any;
}

const AddToBasketModal: FC<Props> = ({
  children = <p>{I18n.t('quick_book.modal.message')}</p>,
  onCheckout = () => {},
  onClose: close = () => {},
  ...props
}) => {
  const router = useRouter();

  const checkout = () =>
    Promise.resolve(onCheckout()).then(() =>
      router.push(I18n.t('navigation.basket.url'))
    );

  return (
    <ModalDialog
      onClose={close}
      showCloseIcon
      headerLabel={I18n.t('quick_book.modal.header_label')}
      size="small"
      primaryAction={
        <button
          className="button button--primary button--medium"
          onClick={checkout}
        >
          {I18n.t('shared.checkout')}
        </button>
      }
      secondaryAction={
        <button
          className="button button--secondary button--medium"
          onClick={close}
        >
          {I18n.t('shared.continue_booking')}
        </button>
      }
      {...props}
    >
      <div className="icon icon--xlarge icon--success icon--centered">
        <i className="fas fa-check-circle" />
      </div>

      {children}
    </ModalDialog>
  );
};

export default AddToBasketModal;
